export default {
  id: -1,
  name: '',
  taxcode: '',
  emails: [],
  address: {
    city: '',
    address: '',
    post_code: '',
    country_code: '',
  },
  phone: '',
  package: {
    id: -1,
    name: '',
  },
  state: 'deleted',
  price_discount: 0
}